import { render, staticRenderFns } from "./AuthResetPasswordForm.vue?vue&type=template&id=48b001c8&scoped=true"
import script from "./AuthResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./AuthResetPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./AuthResetPasswordForm.vue?vue&type=style&index=0&id=48b001c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b001c8",
  null
  
)

export default component.exports